// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__r6oJ6","inputDescription":"styles_inputDescription__1zDds"};